import React from "react";

function OtherInvoice() {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Other Invoice</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a href="#">Dashboard</a>
                </li>
                <li className="breadcrumb-item active">Other Invoice</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Other Invoice</h4>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Invoice No</th>
                      <th>Invoice Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>#INV-1025</td>
                      <td>05.09.2025</td>
                      <td>
                        <button className="btn btn-primary btn-sm">
                          <i className="bi bi-download me-1"></i> Download
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>#INV-1026</td>
                      <td>15.09.2025</td>
                      <td>
                        <button className="btn btn-primary btn-sm">
                          <i className="bi bi-download me-1"></i> Download
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OtherInvoice;
